import * as React from "react";
import { getSupportItemOrList } from "@services/api";
import { useIsFocused } from "@react-navigation/native";

import { useDispatch } from "react-redux";
import SupportListView from "./SupportList";
import { actions } from "@reducers/supportReducer";

import Loader from "../components/CoverLoader";
import exit from "../utils/exit";

const SupportList = ({ navigation, id, isParent }) => {
  const [supportList, setSupportList] = React.useState({ children: [] });
  const [fetching, setFetching] = React.useState(true);
  const [isFirstLoad, setIsFirstLoad] = React.useState(true);
  const isFocused = useIsFocused();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (isFocused) {
      (async function () {
        try {
          let { data } = await getSupportItemOrList({
            id,
            type: "LIST",
            item_id: "",
          });
          const { config = {}, tickets = [] } = data;
          if (
            isParent &&
            config &&
            Array.isArray(config.children) &&
            Array.isArray(tickets) &&
            tickets.length > 0
          ) {
            config.children.unshift({
              // title: "आपके अभी तक के टिकट्स",
              title: null,
              render: "SUPPORT_TICKETS",
              data: [
                {
                  title: "अपने टिकट का स्टेटस चेक करें",
                  render: "RECENT_TICKETS",
                  nextAction: "GOTO_SUPPORT_TICKETS",
                  nextId: "",
                  children: tickets,
                },
              ],
            });
          }

          setSupportList(config);
          setFetching(false);
          setIsFirstLoad(false);

          if (config.item_type === "EXIT") {
            exit(data);
          } else {
            navigation.setParams({
              headerTitle: config.title,
              numberOfLines: 2,
              headerStyle: { width: "80%" },
            });
          }
        } catch (e) {
          console.log(e);
        }
      })();
    }
  }, [fetching, setFetching, isFocused, setIsFirstLoad]);

  const viewProps = {
    supportList,
    isParent,
    handleReloadList: () => setFetching(true),
    fetching,
  };

  dispatch(
    actions.setDissatReasons(supportList?.clTicketDisSatisfactionReasons || []),
  );

  if (fetching && isFirstLoad) {
    return <Loader />;
  }

  return <SupportListView {...viewProps} />;
};

export default SupportList;
